import AgOrderApprove from '@/pages/approveManage/agOrderApprove'
import AgOrderApproveOrderDetail from '@/pages/orderManage/agOrderList/OrderDetail'

export default [
  {
    path: '/agOrderApprove',
    name: 'AgOrderApprove',
    component: AgOrderApprove,
    meta: { name: '待我审批' }
  },
  {
    path: '/agOrderApprove/orderDetail/:orderId',
    name: 'AgOrderApproveOrderDetail',
    component: AgOrderApproveOrderDetail,
    props: true,
    meta: { name: ['订单审批', '订单详情'] }
  }
]



// WEBPACK FOOTER //
// ./src/router/approveManage/agOrderApprove.js